import { Redirect, Route, Switch } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'

import Account from 'components/Account'
import AccountNewPage from 'components/AccountNewPage'
import Admin from 'components/Admin'
import FinishLoginPage from 'components/FinishLoginPage'
import { Flex, FlexContainer } from 'components/Flex'
import LoginPage from 'components/LoginPage'
import NavBar from 'components/NavBar'
import Policy from 'components/Policy'
import Terms from 'components/Terms'
import UserEditPage from 'components/UserEditPage'
import { useAccount } from 'hooks/useAccount'
import useAuth from 'lib/auth'

export default function App() {
  const { initialized, user, isAdmin } = useAuth()
  const { accounts } = useAccount()

  if (!initialized) return null

  // FIXME: react-router-dom のバージョンを上げてここも整理したい
  const Root = () => {
    if (!user) {
      return <Redirect to="/login" />
    }
    if (!user.displayName) {
      return <Redirect to="/user/edit" />
    }
    if (isAdmin) {
      return <Redirect to="/admin" />
    }
    if (accounts === null) {
      return (
        <FlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress />
        </FlexContainer>
      )
    }
    if (accounts.length > 0) {
      return <Redirect to={`/accounts/${accounts[0].id}`} />
    } else {
      return <Redirect to="/accounts/new" />
    }
  }

  return (
    <FlexContainer>
      <NavBar />
      <Flex style={{ background: '#eee' }}>
        <Switch>
          <Route exact path="/">
            <Root />
          </Route>
          <Route path="/login">
            <LoginPage />
          </Route>
          <Route path="/user/edit">
            <UserEditPage />
          </Route>
          <Route path="/finishLogin">
            <FinishLoginPage />
          </Route>
          <Route path="/accounts/new">
            <AccountNewPage />
          </Route>
          <Route path="/accounts/:id">
            <Account />
          </Route>
          <Route path="/admin">
            <Admin />
          </Route>
          <Route path="/terms">
            <Terms />
          </Route>
          <Route path="/policy">
            <Policy />
          </Route>
          <Redirect to="/" />
        </Switch>
      </Flex>
    </FlexContainer>
  )
}
